import type { IRecipesProp } from '../';

const getRecipesOptions = (recipes: IRecipesProp[]): { name: string; id: string }[] => {
  return recipes.map(({ name, recipe_id }) => ({ name: name, id: recipe_id }));
};
export default getRecipesOptions;
